export class TreeViewItem {
  public guid: string | undefined;
  public key: string | undefined;
  public description: string | undefined;
  public isRootCategory: boolean;
  public parent?: TreeViewItem | undefined;
  public children: TreeViewItem[];
  public productCount: number;
  public filteringTechGroupNumber?: string | undefined;
  public expanded: boolean;
  public selected: boolean;
  public nestingDepth: number;
  public isBranch?: boolean | undefined;

  constructor(treeItem: TreeViewItem) {
    this.isRootCategory = false;
    this.productCount = 0;
    this.children = [];
    this.expanded = false;
    this.selected = false;
    this.nestingDepth = -1;

    Object.assign(this, treeItem);
  }
}
